'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Button } from '@/shared/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from '@/shared/components/ui/drawer';
import { useAppContext } from '@/shared/contexts/app';
import { useMediaQuery } from '@/shared/hooks/use-media-query';
import { PricingItem } from '@/shared/types/blocks/pricing';
import { PaymentProviders } from './payment-providers';
export function PaymentModal(t0) {
  const $ = _c(51);
  const {
    isLoading,
    pricingItem,
    onCheckout
  } = t0;
  const t = useTranslations("common.payment");
  const {
    isShowPaymentModal,
    setIsShowPaymentModal
  } = useAppContext();
  const {
    configs
  } = useAppContext();
  const isDesktop = useMediaQuery("(min-width: 768px)");
  if (isDesktop) {
    let t1;
    if ($[0] !== t) {
      t1 = t("choose_payment_method");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <DialogTitle>{t1}</DialogTitle>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t) {
      t3 = t("choose_payment_method_description");
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t3) {
      t4 = <DialogDescription>{t3}</DialogDescription>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
      t5 = <DialogHeader>{t2}{t4}</DialogHeader>;
      $[8] = t2;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== configs || $[12] !== isLoading || $[13] !== onCheckout || $[14] !== pricingItem) {
      t6 = <PaymentProviders callbackUrl="/" configs={configs} loading={isLoading} setLoading={_temp} pricingItem={pricingItem} onCheckout={onCheckout} />;
      $[11] = configs;
      $[12] = isLoading;
      $[13] = onCheckout;
      $[14] = pricingItem;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
      t7 = <DialogContent className="sm:max-w-[425px]">{t5}{t6}</DialogContent>;
      $[16] = t5;
      $[17] = t6;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== isShowPaymentModal || $[20] !== setIsShowPaymentModal || $[21] !== t7) {
      t8 = <Dialog open={isShowPaymentModal} onOpenChange={setIsShowPaymentModal}>{t7}</Dialog>;
      $[19] = isShowPaymentModal;
      $[20] = setIsShowPaymentModal;
      $[21] = t7;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    return t8;
  }
  let t1;
  if ($[23] !== t) {
    t1 = t("choose_payment_method");
    $[23] = t;
    $[24] = t1;
  } else {
    t1 = $[24];
  }
  let t2;
  if ($[25] !== t1) {
    t2 = <DrawerTitle>{t1}</DrawerTitle>;
    $[25] = t1;
    $[26] = t2;
  } else {
    t2 = $[26];
  }
  let t3;
  if ($[27] !== t) {
    t3 = t("choose_payment_method_description");
    $[27] = t;
    $[28] = t3;
  } else {
    t3 = $[28];
  }
  let t4;
  if ($[29] !== t3) {
    t4 = <DrawerDescription>{t3}</DrawerDescription>;
    $[29] = t3;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== t2 || $[32] !== t4) {
    t5 = <DrawerHeader className="text-left">{t2}{t4}</DrawerHeader>;
    $[31] = t2;
    $[32] = t4;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  let t6;
  if ($[34] !== configs || $[35] !== isLoading || $[36] !== onCheckout || $[37] !== pricingItem) {
    t6 = <PaymentProviders callbackUrl="/" configs={configs} loading={isLoading} setLoading={_temp2} pricingItem={pricingItem} onCheckout={onCheckout} className="px-4" />;
    $[34] = configs;
    $[35] = isLoading;
    $[36] = onCheckout;
    $[37] = pricingItem;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== t) {
    t7 = t("cancel_title");
    $[39] = t;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  let t8;
  if ($[41] !== t7) {
    t8 = <DrawerFooter className="pt-4"><DrawerClose asChild={true}><Button variant="outline">{t7}</Button></DrawerClose></DrawerFooter>;
    $[41] = t7;
    $[42] = t8;
  } else {
    t8 = $[42];
  }
  let t9;
  if ($[43] !== t5 || $[44] !== t6 || $[45] !== t8) {
    t9 = <DrawerContent>{t5}{t6}{t8}</DrawerContent>;
    $[43] = t5;
    $[44] = t6;
    $[45] = t8;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] !== isShowPaymentModal || $[48] !== setIsShowPaymentModal || $[49] !== t9) {
    t10 = <Drawer open={isShowPaymentModal} onOpenChange={setIsShowPaymentModal}>{t9}</Drawer>;
    $[47] = isShowPaymentModal;
    $[48] = setIsShowPaymentModal;
    $[49] = t9;
    $[50] = t10;
  } else {
    t10 = $[50];
  }
  return t10;
}
function _temp2() {}
function _temp() {}